import { CalendarDays, HardHat, Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { formatTimestamp, formatBusinessDate } from "@/utils/datetime";

const displayAppointment = (value) => (value ? formatTimestamp(value) : "Not scheduled");

export const ProjectDetailsPanel = ({
  activeJobs,
  appointments,
  canManageActiveJobs,
  onEditActiveJob,
  onEditAppointment,
  onNewActiveJob,
  onNewAppointment,
}) => {
  const now = Date.now();
  const upcomingAppointments = appointments
    .filter((appointment) => new Date(appointment.starts_at).getTime() >= now)
    .slice(0, 3);

  return (
    <section
      className="command-panel command-project-details-panel"
      data-testid="command-project-details"
    >
      <div className="command-panel-heading">
        <div>
          <span className="operations-kicker">Project Details</span>
          <h2>Field work & appointments</h2>
        </div>
      </div>
      <div className="project-details-record-group">
        <div className="project-details-record-heading">
          <span className="project-details-record-label">Active Jobs</span>
          {canManageActiveJobs && (
            <button
              data-testid="project-active-job-new-button"
              onClick={onNewActiveJob}
              type="button"
            >
              <Plus size={14} />
              New field assignment
            </button>
          )}
        </div>
        {activeJobs.length ? (
          activeJobs.slice(0, 2).map((job) => (
            canManageActiveJobs ? (
              <button
                className="command-schedule-row"
                data-testid={`command-active-job-edit-${job.id}`}
                key={job.id}
                onClick={() => onEditActiveJob(job)}
                type="button"
              >
                <HardHat size={15} />
                <span>
                  <strong>Active Job · {job.scheduled_date ? formatBusinessDate(job.scheduled_date) : "Unscheduled"}</strong>
                  <small>
                    {job.foreman || "Foreman pending"} · {job.status}
                  </small>
                </span>
              </button>
            ) : (
              <Link
                className="command-schedule-row"
                data-testid={`command-active-job-${job.id}`}
                key={job.id}
                to={`/active-jobs/${job.id}`}
              >
                <HardHat size={15} />
                <span>
                  <strong>Active Job · {job.scheduled_date ? formatBusinessDate(job.scheduled_date) : "Unscheduled"}</strong>
                  <small>
                    {job.foreman || "Foreman pending"} · {job.status}
                  </small>
                </span>
              </Link>
            )
          ))
        ) : (
          <p className="command-empty-state" data-testid="command-active-job-empty">
            No Active Job assigned.
          </p>
        )}
      </div>
      <div className="project-details-record-group">
        <span className="project-details-record-label">Upcoming Appointments</span>
        <button
          data-testid="project-appointment-new-button"
          onClick={onNewAppointment}
          type="button"
        >
          New appointment
        </button>
        {upcomingAppointments.length ? (
          upcomingAppointments.map((appointment) => (
            <button
              className="command-schedule-row"
              data-testid={`command-appointment-${appointment.id}`}
              key={appointment.id}
              onClick={() => appointment.can_edit && onEditAppointment(appointment)}
              disabled={!appointment.can_edit}
              type="button"
            >
              <CalendarDays size={15} />
              <span>
                <strong>{appointment.title}</strong>
                <small>{displayAppointment(appointment.starts_at)}</small>
              </span>
            </button>
          ))
        ) : (
          <p className="command-empty-state" data-testid="command-appointments-empty">
            No upcoming appointments.
          </p>
        )}
      </div>
    </section>
  );
};